module.exports = __webpack_public_path__ + "static/media/Bantex-logo-black.95843061.png";